<mat-menu #calendarMenu="matMenu">
    <button mat-menu-item class="calendar-google" (click)="iCal.openCalendarLink(scope, 'google')">
        <mat-icon>open_in_new</mat-icon>
        <span>{{ trans.translate('calendarMenu.google') }}</span>
    </button>
    <button mat-menu-item class="calendar-outlook" (click)="iCal.openCalendarLink(scope, 'outlook')">
        <mat-icon>open_in_new</mat-icon>
        <span>{{ trans.translate('calendarMenu.outlook') }}</span>
    </button>
    <button mat-menu-item class="calendar-ics" (click)="iCal.downloadIcs(scope)">
        <mat-icon>download</mat-icon>
        <span>{{ trans.translate('calendarMenu.ics') }}</span>
    </button>
</mat-menu>
